import { h, render, Fragment } from 'preact';
import Icon from '../utils/icon';
import parse from 'html-react-parser';

const ProductReviewHighlightItem = ({ review }) => {
  const customFieldsToRender = ['Height', 'Fit'];
  const wholeStars = Math.floor(review.score);
  const halfStar = !Number.isInteger(review.score);
  const emptyStars = 5 - Math.ceil(review.score);
  const starsClassName = 'w-[15px] h-[15px]';

    const customFieldData = review.custom_fields
      ? Object.values(review.custom_fields).map((field) => {
          if (customFieldsToRender.includes(field.title)) {
            return (
              <p className="text-[14px] leading-[22px] m-0">
                {`${field.title}: `}
                <span className="text-text-2">{`${field.value}`}</span>
              </p>
            );
          }
        })
      : null;

  return (
    <div className="product-review-highlight p-[24px] pr-[15px] flex flex-col gap-[15px] bg-tan-100 rounded-[6px]">
      <h3 className="text-s1">{review.title}</h3>
      <div className="flex gap-[3px]">
        {[...Array(wholeStars)].map(() => (
          <Icon id="star-full" className={starsClassName} />
        ))}
        {halfStar && <Icon id="star-half" className={starsClassName} />}
        {[...Array(emptyStars)].map(() => (
          <Icon id="star-empty" className={starsClassName} />
        ))}
      </div>
      <p className="text-[14px] leading-[22px]">{parse(review.content)}</p>
      <div className="flex items-center gap-[5px]">
        <span className="text-[14px] leading-[22px]">
          {review.user.display_name}
        </span>
        {customFieldData && (
          <>
            <span> — </span>
            {customFieldData}
          </>
        )}
      </div>
    </div>
  );
};

export default ProductReviewHighlightItem;
